"use client";

import dynamic from "next/dynamic";

const ReactPlayerLazy = dynamic(() => import("react-player"), {
  ssr: false,
  loading: () => null,
});

export default ReactPlayerLazy;
